import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LuChevronDown, LuHouse, LuLogOut, LuMoon, LuShieldCheck, LuSun } from 'react-icons/lu';
import DropdownMenu from './ui/DropdownMenu.jsx';
import Avatar from './ui/Avatar.jsx';
import Badge from './ui/Badge.jsx';
import { cx } from '../utils/cx.js';

const roleOf = (user) => {
  if (user?.issuperadmin) return { label: 'Super admin', tone: 'violet' };
  if (user?.isadmin) return { label: 'Admin', tone: 'blue' };
  return null;
};

const displayName = (username = '') => (username ? username.charAt(0).toUpperCase() + username.slice(1) : 'Mon compte');

const UserMenu = ({ currentUser, logout, darkMode, toggleDarkMode }) => {
  const navigate = useNavigate();
  const name = displayName(currentUser?.username);
  const role = roleOf(currentUser);

  const items = [
    {
      heading: (
        <span className="flex items-center gap-2.5 normal-case tracking-normal">
          <Avatar text={name} size="md" round />
          <span className="min-w-0 flex-1">
            <span className="block truncate text-sm font-semibold text-gray-900 dark:text-white">{name}</span>
            {role && <Badge tone={role.tone} size="sm" className="mt-0.5">{role.label}</Badge>}
          </span>
        </span>
      ),
    },
    { divider: true },
    { id: 'home', label: 'Mes rapports', icon: LuHouse, onClick: () => navigate('/') },
    currentUser?.isadmin && { id: 'admin', label: 'Administration', icon: LuShieldCheck, onClick: () => navigate('/admin') },
    {
      id: 'theme',
      label: darkMode ? 'Thème clair' : 'Thème sombre',
      icon: darkMode ? LuSun : LuMoon,
      onClick: toggleDarkMode,
    },
    logout && { divider: true },
    logout && { id: 'logout', label: 'Se déconnecter', icon: LuLogOut, tone: 'danger', onClick: logout },
  ];

  return (
    <DropdownMenu
      label="Menu du compte"
      items={items}
      width="w-64"
      trigger={({ open, toggle, ref, ...aria }) => (
        <button
          ref={ref}
          type="button"
          onClick={toggle}
          {...aria}
          className={cx(
            'flex cursor-pointer items-center gap-2 rounded-lg py-1.5 pl-1.5 pr-2 outline-none transition-colors focus-visible:ring-2 focus-visible:ring-brand-500',
            open ? 'bg-gray-100 dark:bg-white/5' : 'hover:bg-gray-100 dark:hover:bg-white/5',
          )}
        >
          <Avatar text={name} size="sm" round />
          <span className="hidden text-sm font-medium text-gray-700 dark:text-gray-200 sm:inline">{name}</span>
          <LuChevronDown className={cx('h-4 w-4 text-gray-400 transition-transform', open && 'rotate-180')} aria-hidden />
        </button>
      )}
    />
  );
};

export default UserMenu;
